import { Button, ButtonProps, ButtonType } from '@xemplo/button';

import { TestIds } from './create-amendment.helper';

interface CreateAmendmentButtonProps {
  show: boolean;
  onClick: () => void;
  renderButton?: (onClick: () => void) => React.ReactNode;
  buttonProps?: ButtonProps;
  buttonChildren?: string;
}

export function CreateAmendmentButton({
  show,
  onClick,
  renderButton,
  buttonProps,
  buttonChildren,
}: Readonly<CreateAmendmentButtonProps>) {
  if (!show) return null;
  if (renderButton) return <>{renderButton(onClick)}</>;

  return (
    <Button
      ariaLabel="Create Amendment"
      type={ButtonType.Primary}
      testId={TestIds.NewAmendmentButton}
      {...buttonProps}
      onClick={onClick}
    >
      {buttonChildren ?? 'New Amendment'}
    </Button>
  );
}
